import { sneakerSizeBandById } from "@loot-os/fulfillment-core/product-fetch/stockx-size";

/** The listing fields the sizes column reads; the search result carries more. */
export interface ListingWithVariants {
  vendor: string;
  variants: { variantValue: string | null }[] | null;
}

/**
 * The sizes a STOCKX row stores, as StockX names them ("9, 9.5, 10"), in stored order. Null for
 * any other vendor, for a row with no variants, and for one whose variants name no value, so the
 * column shows a dash. A graded card's one variant is its grade ("PSA 10").
 */
export function stockxListingSizes(listing: ListingWithVariants): string | null {
  if (listing.vendor !== "STOCKX") return null;
  const values = (listing.variants ?? []).flatMap((variant) => {
    const trimmedValue = variant.variantValue?.trim();
    return trimmedValue ? [trimmedValue] : [];
  });
  return values.length > 0 ? values.join(", ") : null;
}

/**
 * The size band a StockX band row's id names, as a shopper reads it ("US M 10-10.5"), from the
 * id's `#b:` segment. Null for any other id and for a band id no band has. It reads the id here
 * because `listing/identity` imports the DB schema, which the browser bundle should not carry.
 */
export function sizeBandLabelOfListingId(id: string): string | null {
  const [prefix, , ...segments] = id.split("#");
  if (prefix !== "STOCKX") return null;
  const band = segments.find((segment) => segment.startsWith("b:"));
  return band ? (sneakerSizeBandById(band.slice(2))?.label ?? null) : null;
}
